<template>
  <v-panel>
    <v-form ref="form" v-model="valid" >
      <div class="divider">
        <span>
          <b>Dados do Rebanho de Recria</b>
        </span>
      </div>
      <v-flex md11>
        <div class="divider2 text-xs-center">
          <span class="headline">
            <b>Fêmeas + 36 meses</b>
          </span>
        </div>
        <v-divider></v-divider>
        <v-layout align-center justify-center row wrap>
          <v-flex xs3 sm2 md2>
            <div class="text-xs-center">
              <span>
                <b>Valor</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-text-field
              name="femeas36Valor"
              v-model="formulario.femeas36Valor"
              type="number"
              background-color="white"
              label="R$/Kg"
              box              
            ></v-text-field>
          </v-flex>

          <v-flex xs10 sm4 md4>
            <div class="text-xs-center">
              <span>
                <b>Peso(kg/cab)</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs4 sm4 md5>
                <v-text-field
                  name="femeas36PesoInicial"
                  v-model="formulario.femeas36PesoInicial"
                  type="number"
                  background-color="white"
                  label="Inicial"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs4 sm4 md5>
                <v-text-field
                  name="femeas36PesoFinal"
                  v-model="formulario.femeas36PesoFinal"
                  type="number"
                  background-color="white"
                  label="Final"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs10 sm4 md4>
            <div class="text-xs-center">
              <span>
                <b>Cabeças</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs4 sm4 md5>
                <v-text-field
                  name="femeas36CabecasInicial"
                  v-model="formulario.femeas36CabecasInicial"
                  type="number"
                  background-color="white"
                  label="Inicial"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs4 sm4 md5>
                <v-text-field
                  name="femeas36CabecasFinal"
                  v-model="formulario.femeas36CabecasFinal"
                  type="number"
                  background-color="white"
                  label="Final"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <div class="divider2 text-xs-center">
          <span class="headline">
            <b>Fêmeas 24-36 meses</b>
          </span>
        </div>
        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs3 sm2 md2>
            <div class="text-xs-center">
              <span>
                <b>Valor</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-text-field
              name="femeas2436Valor"
              v-model="formulario.femeas2436Valor"
              type="number"
              background-color="white"
              label="R$/Kg"
              box
            ></v-text-field>
          </v-flex>

          <v-flex xs10 sm4 md4>
            <div class="text-xs-center">
              <span>
                <b>Peso(kg/cab)</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs4 sm4 md5>
                <v-text-field
                  name="femeas2436PesoInicial"
                  v-model="formulario.femeas2436PesoInicial"
                  type="number"
                  background-color="white"
                  label="Inicial"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs4 sm4 md5>
                <v-text-field
                  name="femeas2436PesoFinal"
                  v-model="formulario.femeas2436PesoFinal"
                  type="number"
                  background-color="white"
                  label="Final"
                  box                  
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs10 sm4 md4>
            <div class="text-xs-center">
              <span>
                <b>Cabeças</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs4 sm4 md5>
                <v-text-field
                  name="femeas2436CabecasInicial"
                  v-model="formulario.femeas2436CabecasInicial"
                  type="number"
                  background-color="white"
                  label="Inicial"
                  box                  
                ></v-text-field>
              </v-flex>

              <v-flex xs4 sm4 md5>
                <v-text-field
                  name="femeas2436CabecasFinal"
                  v-model="formulario.femeas2436CabecasFinal"
                  type="number"
                  background-color="white"
                  label="Final"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <div class="divider2 text-xs-center">
          <span class="headline">
            <b>Fêmeas 12-24 meses</b>
          </span>
        </div>
        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs3 sm2 md2>
            <div class="text-xs-center">
              <span>
                <b>Valor</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-text-field
              name="femeas1224Valor"
              v-model="formulario.femeas1224Valor"
              type="number"
              background-color="white"
              label="R$/Kg"
              box
            ></v-text-field>
          </v-flex>

          <v-flex xs10 sm4 md4>
            <div class="text-xs-center">
              <span>
                <b>Peso(kg/cab)</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs4 sm4 md5>
                <v-text-field
                  name="femeas1224PesoInicial"
                  v-model="formulario.femeas1224PesoInicial"
                  type="number"
                  background-color="white"
                  label="Inicial"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs4 sm4 md5>
                <v-text-field
                  name="femeas1224PesoFinal"
                  v-model="formulario.femeas1224PesoFinal"
                  type="number"
                  background-color="white"
                  label="Final"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs10 sm4 md4>
            <div class="text-xs-center">
              <span>
                <b>Cabeças</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs4 sm4 md5>
                <v-text-field
                  name="femeas1224CabecasInicial"
                  v-model="formulario.femeas1224CabecasInicial"
                  type="number"
                  background-color="white"
                  label="Inicial"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs4 sm4 md5>
                <v-text-field
                  name="femeas1224CabecasFinal"
                  v-model="formulario.femeas1224CabecasFinal"
                  type="number"
                  background-color="white"
                  label="Final"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <div class="divider2 text-xs-center">
          <span class="headline">
            <b>Fêmeas 0-12 meses</b>
          </span>
        </div>
        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs3 sm2 md2>
            <div class="text-xs-center">
              <span>
                <b>Valor</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-text-field
              name="femeas012Valor"
              v-model="formulario.femeas012Valor"
              type="number"
              background-color="white"
              label="R$/Kg"
            ></v-text-field>
          </v-flex>

          <v-flex xs10 sm4 md4>
            <div class="text-xs-center">
              <span>
                <b>Peso(kg/cab)</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs4 sm4 md5>
                <v-text-field
                  name="femeas012PesoInicial"
                  v-model="formulario.femeas012PesoInicial"
                  type="number"
                  background-color="white"
                  label="Inicial"
                  box                  
                ></v-text-field>
              </v-flex>

              <v-flex xs4 sm4 md5>
                <v-text-field
                  name="femeas012PesoFinal"
                  v-model="formulario.femeas012PesoFinal"
                  type="number"
                  background-color="white"
                  label="Final"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs10 sm4 md4>
            <div class="text-xs-center">
              <span>
                <b>Cabeças</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs4 sm4 md5>
                <v-text-field
                  name="femeas012CabecasInicial"
                  v-model="formulario.femeas012CabecasInicial"
                  type="number"
                  background-color="white"
                  label="Inicial"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs4 sm4 md5>
                <v-text-field
                  name="femeas012CabecasFinal"
                  v-model="formulario.femeas012CabecasFinal"
                  type="number"
                  background-color="white"
                  label="Final"
                  box                  
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <div class="divider2 text-xs-center">
          <span class="headline">
            <b>Machos 0-12 meses</b>
          </span>
        </div>
        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs3 sm2 md2>
            <div class="text-xs-center">
              <span>
                <b>Valor</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-text-field
              name="machos012Valor"
              v-model="formulario.machos012Valor"
              type="number"
              background-color="white"
              label="R$/Kg"
              box
            ></v-text-field>
          </v-flex>

          <v-flex xs10 sm4 md4>
            <div class="text-xs-center">
              <span>
                <b>Peso(kg/cab)</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs4 sm4 md5>
                <v-text-field
                  name="machos012PesoInicial"
                  v-model="formulario.machos012PesoInicial"
                  type="number"
                  background-color="white"
                  label="Inicial"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs4 sm4 md5>
                <v-text-field
                  name="machos012PesoFinal"
                  v-model="formulario.machos012PesoFinal"
                  type="number"
                  background-color="white"
                  label="Final"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs10 sm4 md4>
            <div class="text-xs-center">
              <span>
                <b>Cabeças</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs4 sm4 md5>
                <v-text-field
                  name="machos012CabecasInicial"
                  v-model="formulario.machos012CabecasInicial"
                  type="number"
                  background-color="white"
                  label="Inicial"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs4 sm4 md5>
                <v-text-field
                  name="machos012CabecasFinal"
                  v-model="formulario.machos012CabecasFinal"
                  type="number"
                  background-color="white"
                  label="Final"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <div class="divider2 text-xs-center">
          <span class="headline">
            <b>Machos 12-24 meses</b>
          </span>
        </div>
        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs3 sm2 md2>
            <div class="text-xs-center">
              <span>
                <b>Valor</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-text-field
              name="machos1224Valor"
              v-model="formulario.machos1224Valor"
              type="number"
              background-color="white"
              label="R$/Kg"
              box
            ></v-text-field>
          </v-flex>

          <v-flex xs10 sm4 md4>
            <div class="text-xs-center">
              <span>
                <b>Peso(kg/cab)</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs4 sm4 md5>
                <v-text-field
                  name="machos1224PesoInicial"
                  v-model="formulario.machos1224PesoInicial"
                  type="number"
                  background-color="white"
                  label="Inicial"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs4 sm4 md5>
                <v-text-field
                  name="machos1224PesoFinal"
                  v-model="formulario.machos1224PesoFinal"
                  type="number"
                  background-color="white"
                  label="Final"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs10 sm4 md4>
            <div class="text-xs-center">
              <span>
                <b>Cabeças</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs4 sm4 md5>
                <v-text-field
                  name="machos1224CabecasInicial"
                  v-model="formulario.machos1224CabecasInicial"
                  type="number"
                  background-color="white"
                  label="Inicial"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs4 sm4 md5>
                <v-text-field
                  name="machos1224CabecasFinal"
                  v-model="formulario.machos1224CabecasFinal"
                  type="number"
                  background-color="white"
                  label="Final"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <div class="divider2 text-xs-center">
          <span class="headline">
            <b>Machos 24-36 meses</b>
          </span>
        </div>
        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs3 sm2 md2>
            <div class="text-xs-center">
              <span>
                <b>Valor</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-text-field
              name="machos2436Valor"
              v-model="formulario.machos2436Valor"
              type="number"
              background-color="white"
              label="R$/Kg"
              box
            ></v-text-field>
          </v-flex>

          <v-flex xs10 sm4 md4>
            <div class="text-xs-center">
              <span>
                <b>Peso(kg/cab)</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs4 sm4 md5>
                <v-text-field
                  name="machos2436PesoInicial"
                  v-model="formulario.machos2436PesoInicial"
                  type="number"
                  background-color="white"
                  label="Inicial"
                  box                  
                ></v-text-field>
              </v-flex>

              <v-flex xs4 sm4 md5>
                <v-text-field
                  name="machos2436PesoFinal"
                  v-model="formulario.machos2436PesoFinal"
                  type="number"
                  background-color="white"
                  label="Final"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs10 sm4 md4>
            <div class="text-xs-center">
              <span>
                <b>Cabeças</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs4 sm4 md5>
                <v-text-field
                  name="machos2436CabecasInicial"
                  v-model="formulario.machos2436CabecasInicial"
                  type="number"
                  background-color="white"
                  label="Inicial"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs4 sm4 md5>
                <v-text-field
                  name="machos2436CabecasFinal"
                  v-model="formulario.machos2436CabecasFinal"
                  type="number"
                  background-color="white"
                  label="Final"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <div class="divider2 text-xs-center">
          <span class="headline">
            <b>Machos + 36 meses inclusive tourunos</b>
          </span>
        </div>
        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs3 sm2 md2>
            <div class="text-xs-center">
              <span>
                <b>Valor</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-text-field
              name="machos36Valor"
              v-model="formulario.machos36Valor"
              type="number"
              background-color="white"
              label="R$/Kg"
              box              
            ></v-text-field>
          </v-flex>

          <v-flex xs10 sm4 md4>
            <div class="text-xs-center">
              <span>
                <b>Peso(kg/cab)</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs4 sm4 md5>
                <v-text-field
                  name="machos36PesoInicial"
                  v-model="formulario.machos36PesoInicial"
                  type="number"
                  background-color="white"
                  label="Inicial"                  
                ></v-text-field>
              </v-flex>

              <v-flex xs4 sm4 md5>
                <v-text-field
                  name="machos36PesoFinal"
                  v-model="formulario.machos36PesoFinal"
                  type="number"
                  background-color="white"
                  label="Final"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs10 sm4 md4>
            <div class="text-xs-center">
              <span>
                <b>Cabeças</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs4 sm4 md5>
                <v-text-field
                  name="machos36CabecasInicial"
                  v-model="formulario.machos36CabecasInicial"
                  type="number"
                  background-color="white"
                  label="Inicial"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs4 sm4 md5>
                <v-text-field
                  name="machos36CabecasFinal"
                  v-model="formulario.machos36CabecasFinal"
                  type="number"
                  background-color="white"
                  label="Final"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <div class="divider2 text-xs-center">
        <div class="headline">
          <span>
            <b>Rebanho médio anual estimado</b>
          </span>
        </div>
        </div>
        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs4 sm2 md2>
            <v-text-field
              name="rebanhoMedioAnualEstimadoCabeca"
              v-model="formulario.rebanhoMedioAnualEstimadoCabeca"
              type="number"
              background-color="white"
              label="Cabeças"
              box
            ></v-text-field>
          </v-flex>

          <v-flex xs4 sm2 md2>
            <v-text-field
              name="rebanhoMedioAnualEstimadoUA"
              v-model="formulario.rebanhoMedioAnualEstimadoUA"
              type="number"
              background-color="white"
              label="UA"
              box
            ></v-text-field>
            {{form}}
          </v-flex>
        </v-layout>
      </v-flex>
    </v-form>
  </v-panel>
</template>
<script>
/* eslint-disable */
import RebanhoDeRecria from "../../class/RebanhoDeRecria.js";
export default {
  inject: ["$validator"],
  data: () => ({
    formulario: new RebanhoDeRecria(),
    panel: [],
    lazy: true,
    valid: false,
    simulation: ''
  }),
  mounted() {
    var self = this;
    this.$db.simulation.get(this.$route.params.code, function(s) {
      self.simulation = s;
    });
  },
  computed: {
    form: function() {
      this.$db.simulation.get({ code: this.simulation.code }, dado => {
        this.formulario = new RebanhoDeRecria(dado.rebanhoRecria);
      });
    }
  },

  methods: {
    clear() {
      this.formulario = {
        formulario: Object.assign(this.$data, this.$options.data.apply())
      };
      this.$validator.reset();
    }
  }
};
</script>
<style scoped>
h2 {
  color: #00695c;
}

.botaoNone {
  border: solid black 1px;
  position: fixed;
  margin-bottom: 0;
  z-index: 997;
  bottom: 45px;
  right: 24px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}

@media screen and (max-width: 991px) {
  h2 {
    color: #00695c;
  }
  .container {
    position: relative;
    text-align: center;

    background-color: #00695c;
    min-height: 100vh;
    max-width: none;

    color: azure;
  }

  .panel {
    margin-top: 1%;
    padding-left: 2%;
    padding-right: 2%;
    padding-bottom: 1%;
    background-color: white;
    box-shadow: 0 4px 15px black;
  }
  .form {
    margin-top: 2%;

    min-width: 100%;
  }
  .text-field {
    background-color: blue;
    font-size: 2px;
  }
  .flex {
    margin-left: auto;
    margin-right: auto;
    margin-top: 2%;
  }
  .button {
    float: right;
  }
  .divider {
    text-align: center;
    font-size: 130%;
    color: #00695c;
  }
  .divider2 text-xs-center {
    margin-top: 5%;
    margin-left: 5%;
    font-size: 110%;
  }
}

@media screen and (min-width: 992px) {
  h2 {
    color: #00695c;
  }
  .container {
    margin-top: 2%;
    text-align: center;

    background-color: #00695c;
    min-height: 100vh;
    max-width: none;

    color: azure;
  }
  .panel {
    width: 60%;
    margin-left: auto;
    margin-right: auto;
    margin-top: 2%;
    padding-bottom: 1%;
    background-color: white;
    box-shadow: 0 4px 10px black;
  }
  .panelGrafico {
    width: 70%;
  }
  .flex {
    margin-left: auto;
    margin-right: auto;
    margin-top: 2%;
  }

  .button {
    float: right;
  }

  .divider {
    text-align: center;
    font-size: 180%;
    color: #00695c;
  }
  .divider2 text-xs-center {
    font-size: 150%;
    margin-top: 5%;
    margin-left: 5%;
  }
  .layout {
    padding-left: 5%;
    padding-right: 5%;
  }
}
</style>